import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

/**
 * The app boots straight into the shell. There is no provider wrapper anymore: Clerk's
 * `ClerkProvider` (which threw outright without a publishable key, and forced the
 * "configure then rebuild" dead end) is gone, and the first-party session lives in
 * `web/src/api/token.ts` — a plain store the SPA reads without a provider.
 */
const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
